<app-base-edit-form [fields]="fields" [baseService]="roleService" [closeOnSave]="false" (saved)="saved.emit()">
</app-base-edit-form>
